import { matchPath, useLocation } from 'react-router';

// ----------------------------------------------------------------------

type ReturnType = boolean;

export function useActiveLink(path: string, deep = true): ReturnType {
  const { pathname } = useLocation();

  // Check if the pathname starts with the path and matches the first 2 segments of the route
  const isPathContained =
    pathname.startsWith(path) && pathname.split('/').slice(0, 3).join('/') === path;

  const normalActive = path ? !!matchPath({ path, end: true }, pathname) || isPathContained : false;

  const deepActive = path ? !!matchPath({ path, end: false }, pathname) : false;

  return deep ? deepActive : normalActive;
}
